module.exports = __webpack_public_path__ + "img/tg_cl02.9afc2d4a.png";